import { render, staticRenderFns } from "./LineSupermarket.vue?vue&type=template&id=09bef6f6&scoped=true"
import script from "./LineSupermarket.vue?vue&type=script&lang=js"
export * from "./LineSupermarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bef6f6",
  null
  
)

export default component.exports